import { render, staticRenderFns } from "./WebhookCard.vue?vue&type=template&id=792039c2&"
import script from "./WebhookCard.vue?vue&type=script&lang=js&"
export * from "./WebhookCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports